module.exports = __webpack_public_path__ + "static/media/dgocean.799cee05.svg";